import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequestSmpAsDatafan } from "../../_helpers";
export class ApiDatafanSmpAccounts {
}
ApiDatafanSmpAccounts.connect = (socialAuthData) => apiRequestSmpAsDatafan({
    body: socialAuthData,
    endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/connect`,
    method: "POST",
});
ApiDatafanSmpAccounts.credentialDelete = (accountId) => apiRequestSmpAsDatafan({
    endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/credential/${accountId}`,
    method: "DELETE",
});
ApiDatafanSmpAccounts.list = (query) => apiRequestSmpAsDatafan({
    endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/credential/`,
    method: "GET",
    query,
});
//# sourceMappingURL=accounts.js.map